import { VehicleTest } from "@/types/vehicleTest";
import { generateVehicleTestPdfPro } from "./pdfGeneratorPro";
import { getLanguage } from "@/utils/languageUtils";
import { carTestLabels } from "@/i18n/labels";

/** Resolve image URLs from mediaId so PDF can embed them. Returns a copy of test with urls set. */
export async function resolveTestImageUrls(
  test: VehicleTest,
  getDownloadUrlAsync: (params: { mediaId: string; expiresIn?: number }) => Promise<string>
): Promise<VehicleTest> {
  const copy = JSON.parse(JSON.stringify(test)) as VehicleTest;
  const resolve = async (img: { url?: string; mediaId?: string }) => {
    if (img?.mediaId && !img?.url) {
      try {
        img.url = await getDownloadUrlAsync({ mediaId: img.mediaId, expiresIn: 3600 });
      } catch {
        // keep url undefined on failure
      }
    }
  };
  const sections = [
    ...(copy.images?.exterior || []),
    ...(copy.images?.interior || []),
    ...(copy.images?.damage || []),
    ...(copy.images?.serviceImages || []),
    ...(copy.images?.tires?.primary || []),
    ...(copy.images?.tires?.secondary || []),
  ];
  await Promise.all(sections.map(resolve));
  return copy;
}

/**
 * Genererar och laddar ner en professionell PDF för fordonstest.
 * Innehåll: BILENIA-header, datum, sidnummer, säljarinfo, pris, bilder per sektion,
 * fordonsinformation, ytterligare information, däck & nycklar, fordonstest, kommentarer.
 */
export const generateVehicleTestPdf = async (test: VehicleTest, lang?: string): Promise<void> => {
  const pdf = await generateVehicleTestPdfPro(test, lang);
  const language = lang || getLanguage();
  const ct = carTestLabels(language);
  const fileName = `${ct.pdf.title.toLowerCase().replace(/\s+/g, "-")}-${test.vehicleDetails?.regNumber || test.regNumber || "unknown"}.pdf`;
  const { savePdfDocument } = await import("@/lib/native/savePdf");
  await savePdfDocument(pdf, fileName);
};